import React from 'react';
import { useUrlBuilder } from 'hooks/useUrlBuilder';
import { TextContainer } from './common';
import { mailTo, customerCareEmail } from '../../../helpers/emailAddresses';
import { faq } from '../../../helpers/routes';

export const CustomerSupport: React.FC<{}> = () => {
  const { localized } = useUrlBuilder();
  return (
    <>
      <TextContainer>
        Questions, concerns, issues?
        <br /> Visit our{' '}
        <a href={localized(faq)} style={{ fontSize: '15px', textDecoration: 'underline' }}>
          FAQ
        </a>{' '}
        or contact us:{' '}
        <a href={mailTo(customerCareEmail)} style={{ fontSize: '15px', textDecoration: 'underline' }}>
          customercare@italist.com
        </a>
        .<br /> We’re always here for you &#x2764;&#xFE0E;
      </TextContainer>
    </>
  );
};
